import { createTheme, adaptV4Theme } from '@mui/material/styles';

import colors from './colors';

export default createTheme(
    adaptV4Theme({
        typography: {
            fontFamily: 'Roboto'
        },
        palette: {
            primary: {
                main: colors.primary,
                contrastText: 'white'
            },
            secondary: {
                main: colors.secondary
            }
        },
        overrides: {
            MuiButton: {
                root: {
                    background: '#fff'
                },
                outlined: {
                    borderRadius: '20px'
                },
                outlinedSecondary: {
                    '&:hover': {
                        backgroundColor: 'rgba(255,255,255, 0.9)'
                    }
                }
            }
        }
    })
);
